export const SHOW_ERROR_PAGE = 'ERROR_PAGE';
